import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUserInfo } from "../Redux/userInfoSlice";

import { httpsCallable } from "firebase/functions";
import { onAuthStateChanged } from "firebase/auth";
import { fireDb, fireAuth, fireFunctions } from "../Firebase/firebase";
import { setUserLoading } from "../Redux/userLoadingSlice";
import { collection, getDocs, query, where } from "firebase/firestore/lite";
import { setUser } from "../Redux/userSlice";

// currently not using update version. this can be done manually for each connected voter when the voter list updates.
// const userUpdateVersion = "apr_2025";

export const useProcessAuthChange = () => {
  const dispatch = useDispatch();

  // this function will fetch or create and fetch the firestore document for the signed in user.
  const setUpAndFetchUser = async (user) => {
    // first, fetch the document if it exists:
    const unvUsersRef = collection(fireDb, "unverifiedUsers");
    let q;
    if (user.phoneNumber) {
      q = query(
        unvUsersRef,
        where("phones", "array-contains", user.phoneNumber),
      );
    } else if (user.email) {
      q = query(unvUsersRef, where("emails", "array-contains", user.email));
    }
    const querySnapshot = await getDocs(q);

    // go through all the matched user docs
    const matchedUsers = [];
    querySnapshot.forEach((doc) => {
      const matchedUser = { fsDocId: doc.id, ...doc.data() };
      matchedUsers.push(matchedUser);
    });

    // get the signed in user doc from what was queried or create it from scratch.
    let signedInUserDoc = null;
    if (matchedUsers.length === 0) {
      // call the backend set up function and retrieve the newly created document.
      const writeAndFetchUser = httpsCallable(fireFunctions, "writeUnvUser");
      dispatch(setUserLoading(true));
      const response = await writeAndFetchUser({});
      const matchedUsersBackend = response?.data || [];
      if (matchedUsersBackend.length > 0) {
        signedInUserDoc = matchedUsersBackend[0];
      }
    } else {
      signedInUserDoc = matchedUsers[0]; // in the future, can handle an error where there are multiple matched voters.
    }

    return signedInUserDoc;
  };

  const onAuthChange = (user) => {
    // dispatch user info, whether it's null or actual user info
    // this corresponds to the firebase authenticated user (different from firestore document)
    dispatch(
      setUserInfo({
        uid: user?.uid,
        phone: user?.phoneNumber,
        email: user?.email,
      }),
    );

    if (user) {
      setUpAndFetchUser(user)
        .then((matchedUser) => {
          // this function sets up the user and returns the doc. we will dispatch it.
          dispatch(setUser(matchedUser));
          // turn off loader.
          dispatch(setUserLoading(false));
        })
        .catch(() => {
          dispatch(setUserLoading(false));
        });
    } else {
      dispatch(setUser(null));
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(fireAuth, onAuthChange);

    // the cleanup removes the listener
    return () => unsubscribe();
  }, []);
};
